// 音频控制器 - 管理所有音频实例
export const audioController = {
  // 存储所有活跃的音频实例
  activeAudios: [],
  
  // 注册新的音频实例
  registerAudio(audio) {
    this.activeAudios.push(audio);
  },
  
  // 从列表中移除音频实例
  unregisterAudio(audio) {
    this.activeAudios = this.activeAudios.filter(a => a !== audio);
  },
  
  // 停止所有其他音频
  stopOtherAudios(currentAudio) {
    this.activeAudios.forEach(audio => {
      if (audio !== currentAudio && !audio.paused) {
        audio.pause();
      }
    });
  }
};
    